import { useCallback } from 'react';
import {
	ENTRY_POINT_ID_COMPASS,
	EntryKeys,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import type { FeedbackCollectorProps } from '@atlassian/jira-feedback-collector/src/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { feedback } from './constants.tsx';
import messages from './messages.tsx';

export const useCompassComponentsFeedbackCollectorActions = () => {
	const { formatMessage } = useIntl();
	const { openFeedbackCollector } = useFeedbackCollectorActions();

	const openGlobalComponentsFeedbackCollector = useCallback(
		(props?: Partial<FeedbackCollectorProps>) => {
			openFeedbackCollector({
				feedbackGroupId: feedback.GLOBAL_COMPONENTS,
				entrypointId: ENTRY_POINT_ID_COMPASS,
				feedbackTitle: formatMessage(messages.feedbackTitle),
				showTypeField: true,
				showDefaultTextFields: true,
				submitButtonLabel: formatMessage(messages.submitButtonLabel),
				feedbackContext: [
					{
						id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION,
						value: feedback.LOCATION,
					},
				],
				...props,
			});
		},
		[formatMessage, openFeedbackCollector],
	);

	return { openGlobalComponentsFeedbackCollector };
};
